import React from 'react';
import {Box, styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import ElementPosition from '@contentlab/types/elementPosition';

const PositionGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  padding: '0px 24px 24px 24px',
}));

const PositionItemContainer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'isSelected',
})<{isSelected: boolean}>(({isSelected}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '48px',
  backgroundColor: isSelected
    ? designSystemToken('semantic.bg.brand-secondary')
    : designSystemToken('semantic.bg.primary'),
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
  borderRadius: '4px',
}));

function positionItem(
  position: ElementPosition,
  isSelected: boolean,
  onPositionSelect: (position: ElementPosition) => void
) {
  return (
    <PositionItemContainer
      key={position}
      isSelected={isSelected}
      onClick={() => onPositionSelect(position)}
    >
      <Box
        width="10px"
        height="10px"
        borderRadius="5px"
        sx={{
          backgroundColor: isSelected
            ? designSystemToken('semantic.fg.primary')
            : designSystemToken('semantic.fg.tertiary'),
        }}
      />
    </PositionItemContainer>
  );
}

interface AvatarPositionSectionProps {
  testID?: string;
  selectedPosition: ElementPosition;
  onPositionSelect: (position: ElementPosition) => void;
}

function AvatarPositionSection({
  testID = 'avatar-position-section',
  selectedPosition,
  onPositionSelect,
}: AvatarPositionSectionProps) {
  const gridPositions = [
    ElementPosition.TOP_LEFT,
    ElementPosition.TOP_CENTER,
    ElementPosition.TOP_RIGHT,
    ElementPosition.MIDDLE_LEFT,
    ElementPosition.MIDDLE_CENTER,
    ElementPosition.MIDDLE_RIGHT,
    ElementPosition.BOTTOM_LEFT,
    ElementPosition.BOTTOM_CENTER,
    ElementPosition.BOTTOM_RIGHT,
  ];

  return (
    <PositionGrid data-testid={testID}>
      {gridPositions.map((position: ElementPosition) => {
        return positionItem(
          position,
          selectedPosition === position,
          onPositionSelect
        );
      })}
    </PositionGrid>
  );
}

export default AvatarPositionSection;
